(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sua-design"]) return;
  try {
    
function initSuaNavigationCase(){
  const labels={'HOME':'Home','SEARCH':'Search','CATEGORIES':'Categories','BROWSE PRODUCTS':'Browse Products'};
  document.querySelectorAll('.site-header,.nav-bar,#NavDrawer').forEach(root=>{
    if(root.dataset.suaCaseBound)return;root.dataset.suaCaseBound='true';
    const normalize=()=>{const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode()){const value=node.nodeValue.trim();if(labels[value]){node.nodeValue=node.nodeValue.replace(value,labels[value]);node.parentElement?.setAttribute('data-sua-nav-label','');}}};
    normalize();new MutationObserver(normalize).observe(root,{childList:true,subtree:true,characterData:true});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSuaNavigationCase);else initSuaNavigationCase();
document.addEventListener('shopify:section:load',initSuaNavigationCase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sua-home"] && !Shopify.designMode) return;
  try {
    
function initSuaFilm(){
  const film=document.getElementById('sua-hero-video');
  const toggle=document.getElementById('video-toggle');
  if(!film||!toggle||film.dataset.bound)return;
  film.dataset.bound='true';
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  const sync=()=>{toggle.textContent=film.paused?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-label',toggle.textContent);};
  film.muted=true;
  if(reduce.matches||navigator.connection?.saveData)film.pause();
  else film.play().catch(sync);
  toggle.addEventListener('click',()=>{if(film.paused)film.play().catch(sync);else film.pause();});
  film.addEventListener('play',sync);film.addEventListener('pause',sync);
  film.addEventListener('error',()=>{toggle.textContent=toggle.dataset.play;film.controls=true;});
  reduce.addEventListener('change',e=>{if(e.matches)film.pause();});
  sync();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSuaFilm);else initSuaFilm();
document.addEventListener('shopify:section:load',initSuaFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sua-product"] && !Shopify.designMode) return;
  try {
    
function initSuaProducts(){document.querySelectorAll('[data-sua-product]').forEach(root=>{
  if(root.dataset.bound)return;root.dataset.bound='true';
  const variants=JSON.parse(root.querySelector('[data-sua-variants]').textContent);
  const select=root.querySelector('[data-sua-variant]');
  const fields=[...root.querySelectorAll('[data-option-position]')];
  const main=root.querySelector('.sua-pdp-main-image');
  const dialog=root.querySelector('dialog');
  const zoom=root.querySelector('.sua-pdp-zoom-image');
  const add=root.querySelector('[data-sua-add]');
  const stock=root.querySelector('[data-sua-stock]');
  const showImage=(src,alt)=>{if(!src||!main)return;main.removeAttribute('srcset');main.src=src;main.alt=alt||'';if(zoom){zoom.removeAttribute('srcset');zoom.src=src;zoom.alt=alt||'';}root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.image===src)));};
  root.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>showImage(button.dataset.image,button.dataset.alt)));
  root.querySelector('[data-zoom-open]')?.addEventListener('click',()=>dialog.showModal());
  root.querySelector('[data-zoom-close]')?.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  root.querySelectorAll('[data-qty]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name="quantity"]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.qty));input.dispatchEvent(new Event('change',{bubbles:true}));}));
  const update=()=>{
    const options=fields.map(field=>field.querySelector('input:checked')?.value);
    const variant=fields.length?variants.find(v=>v.options.every((value,i)=>value===options[i])):variants.find(v=>String(v.id)===select.value);
    add.disabled=!variant?.available;
    add.textContent=variant?(variant.available?root.dataset.add:root.dataset.sold):root.dataset.unavailable;
    stock.textContent=variant?(variant.available?root.dataset.available:root.dataset.sold):root.dataset.unavailable;
    root.querySelector('[data-sua-payment]').hidden=!variant?.available;
    if(!variant){select.value='';root.querySelector('[data-sua-sku]').textContent='—';return;}
    select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));
    root.querySelector('[data-sua-price]').textContent=variant.price;
    const compare=root.querySelector('[data-sua-compare]');compare.textContent=variant.compare||'';compare.hidden=!variant.compare;
    root.querySelector('[data-sua-sku]').textContent=variant.sku||'—';
    showImage(variant.image,variant.alt);
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
  };
  fields.forEach(field=>field.addEventListener('change',update));
  root.querySelector('.sua-pdp-options')?.removeAttribute('hidden');
  root.querySelector('.sua-pdp-native-select').hidden=true;
  root.querySelector('form').addEventListener('submit',e=>{if(add.disabled)e.preventDefault();});
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSuaProducts);else initSuaProducts();
document.addEventListener('shopify:section:load',initSuaProducts);

  } catch(e) { console.error(e); }
})();
})();
